
























































































import InputField from "../../../core/Forms/InputField.vue";
import { RecurrenceInterventionApi } from "../../../api/RecurrenceInterventionApi";
import { RecurrenceIntervention } from "../../../models/RecurrenceIntervention";
import Remplacement = RecurrenceIntervention.Remplacement;
import Dropdown from "../../../core/UI/Dropdown.vue";
import RemplacementModal from "../../RemplacementModal.vue";

export default {
    name: "RemplacementsInput",
    components: { Dropdown, InputField, RemplacementModal },
    props: {
        recurrenceIntervention: RecurrenceIntervention,
        remplacements: Array,
        label: String,
        hideCreateButton: Boolean,
        hideDeleteButton: Boolean,
    },
    data() {
        return {
            selectedRemplacement: null,
            newRemplacement: false,
            RecurrenceInterventionApi: new RecurrenceInterventionApi(),
        };
    },
    created() {
        let self = this;
        _.each(self.remplacements, function (remplacement) {
            if (remplacement.id) {
                self.RecurrenceInterventionApi.getRemplacement(
                    self.recurrenceIntervention.id,
                    remplacement.id,
                    { include: "recurrence_interventions" }
                ).then(function (res) {
                    remplacement.recurrence_interventions =
                        res.recurrence_interventions;
                });
            }
        });
    },
    methods: {
        addRemplacement() {
            let self = this;
            self.selectedRemplacement = null;
            self.newRemplacement = false;
            setTimeout(function () {
                self.newRemplacement = true;
            });
        },
        editRemplacement(remplacement: Remplacement) {
            let self = this;
            self.newRemplacement = false;
            self.selectedRemplacement = null;
            setTimeout(function () {
                self.selectedRemplacement = remplacement;
            });
        },
        deleteRemplacement(remplacement: Remplacement) {
            let self = this;
            swal({
                title: "Voulez vous supprimer ce remplacement ?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-danger",
                confirmButtonText: "Supprimer",
                cancelButtonClass: "btn btn-default",
                cancelButtonText: "Annuler",
                buttonsStyling: false,
            }).then(function () {
                self.RecurrenceInterventionApi.removeRemplacement(
                    remplacement.id
                ).then(function () {
                    _.remove(self.remplacements, { id: remplacement.id });
                    _.each(
                        remplacement.recurrence_interventions_ids,
                        function (recurrenceInterventionId) {
                            self.RecurrenceInterventionApi.resetInterventionRecurrente(
                                recurrenceInterventionId,
                                remplacement.start_date_str
                            );
                        }
                    );
                    self.$forceUpdate();
                });
            });
        },
        onModalClose(updatedRemplacement?: Remplacement) {
            let self = this;
            if (updatedRemplacement) {
                _.remove(self.remplacements, { id: updatedRemplacement.id });
                self.remplacements.push(updatedRemplacement);
            }
        },
        defaultEmploye() {
            return _.first(this.recurrenceIntervention.employes);
        },
    },
};
